module.exports = __webpack_public_path__ + "assets/img/jianjiang01.399fbf4d.png";